export default __webpack_public_path__ + "static/media/ic_trading.15843c13.svg";